// notification.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  title?: string;
  message: string;
  duration?: number;
  icon?: string;
  backgroundColor?: string;
  color?: string;
  action?: {
    label: string;
    callback: () => void;
  };
  closable?: boolean;
}

@Injectable({
  providedIn: 'root' 
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();
  private idCounter = 0;

  success(message: string, title?: string, duration: number = 5000): void {

    this.showNotification('success', message, title, duration);
  }

  error(message: string, title?: string, duration: number = 6000): void {
    this.showNotification('error', message, title, duration);
  }

  info(message: string, title?: string, duration: number = 4000): void {
    this.showNotification('info', message, title, duration);
  }

  warning(message: string, title?: string, duration: number = 5000): void {
    this.showNotification('warning', message, title, duration);
  }

  showWithAction(
    message: string,
    actionLabel: string,
    actionCallback: () => void,
    type: 'success' | 'error' | 'info' | 'warning' = 'info',
    title?: string,
    duration: number = 0
  ): void {
    const notification: Notification = {
      id: this.generateId(),
      type,
      title,
      message,
      duration,
      action: {
        label: actionLabel,
        callback: actionCallback
      },
      closable: true
    };
    this.addNotification(notification);
  }

  remove(id: string): void {
    const current = this.notificationsSubject.value;
    this.notificationsSubject.next(current.filter(n => n.id !== id));
  }

  clear(): void {
    this.notificationsSubject.next([]);
  }

  private showNotification(
    type: Notification['type'],
    message: string,
    title?: string,
    duration: number = 5000
  ): void {
    const notification: Notification = {
      id: this.generateId(),
      type,
      title,
      message,
      duration,
      closable: true
    };
    console.log(notification)
    this.addNotification(notification);
  }

  private addNotification(notification: Notification): void {
    const current = this.notificationsSubject.value;
    this.notificationsSubject.next([...current, notification]);

    if (notification.duration && notification.duration > 0) {
      setTimeout(() => {
        this.remove(notification.id);
      }, notification.duration);
    }
  }

  private generateId(): string {
    return `notification-${++this.idCounter}-${Date.now()}`;
  }
}